import { render, staticRenderFns } from "./TopicTypeStat.vue?vue&type=template&id=092ba823&scoped=true&"
import script from "./TopicTypeStat.vue?vue&type=script&lang=js&"
export * from "./TopicTypeStat.vue?vue&type=script&lang=js&"
import style0 from "./TopicTypeStat.vue?vue&type=style&index=0&id=092ba823&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092ba823",
  null
  
)

export default component.exports